import shared_routes from 'routes/shared'
import all_team_routes from 'routes/all-team/inventory-all-team-routes'
import cs_team_routes from 'routes/cs-team'
import inbound_team_routes from 'routes/inbound-team'
import outbound_team_routes from 'routes/outbound-team'
import photo_studio_team_routes from 'routes/photo-studio-team'
import studio_team_routes from 'routes/studio-team'
import inventory_batch_team_routes from 'routes/inventory-batch-team'
import warehouse_team_routes from 'routes/warehouse-team'
import photo_editor_team_routes from 'routes/photo-editor-team'
import finance_team_routes from 'routes/finance-team'
import merchandise_team_routes from 'routes/merchandise-team/merchandise-team-routes'
import hr_team_routes from 'routes/hr-team/hr-team-routes'
import marketing_team_routes from 'routes/marketing-team'
import sales_team_routes from 'routes/sales-team'
import purchasing_team_routes from './purchasing-team/purchasing-team-routes'
import inventory_system_routes from './inventory-system'
import inbound_journey_routes from './inbound-journey'
import product_curated_team_routes from 'routes/product-curated-team'
import setting_routes from 'routes/setting/setting-routes'
import legacy_operations_routes from 'routes/legacy-operations/legacy-operations-routes'
import marketing_migration_routes from 'routes/marketing-team/migration-routes'
import voucher_routes from 'routes/marketing-team/voucher-routes'
import organizeSidebarRoutes from './organize-sidebar-routes'

const routes = [
  /** Shared Routes defines pages that render data for a resource*/
  ...shared_routes,
  all_team_routes,
  sales_team_routes,
  voucher_routes,
  marketing_migration_routes,
  finance_team_routes,
  purchasing_team_routes,
  product_curated_team_routes,
  studio_team_routes,
  inbound_team_routes,
  outbound_team_routes,
  setting_routes,
  legacy_operations_routes,
  inbound_journey_routes,
  // all_team_routes,
  // merchandise_team_routes,
  // inbound_team_routes,
  // photo_studio_team_routes,
  // photo_editor_team_routes,
  // inventory_batch_team_routes,
  // warehouse_team_routes,
  // cs_team_routes,
  // inbound_journey_routes,
  // hr_team_routes,
  // marketing_team_routes
]

export default organizeSidebarRoutes(routes)
